import ProcessAttentionVehicleModal from './process-attention-vehicle-modal.vue'
export default ProcessAttentionVehicleModal
